module.exports = __webpack_public_path__ + "img/tuandui.7451f2f9.png";